<mat-card class="info-card pt-0">
  <mat-card-header class="info-card-header w-100 d-block">
    <div class="row">
      <div class="col-auto">
        <mat-card-title class="title">{{ "Receivers.PermitAccess" | translate }}</mat-card-title>
      </div>
      <div class="col-auto ml-auto" *ngIf="isCustomerTypeSAAS">
        <button type="button" mat-flat-button class="p-0" (click)="openAddPermitDialog()">
          <span class="flex align-center text-primary">
            <mat-icon>add_circle_outline</mat-icon>
            <span class="text-underline text-bold">{{'Buttons.AddPermitAccess' | translate}}</span>
          </span>
        </button>
      </div>
    </div>
  </mat-card-header>

  <mat-divider class="pos-static my-4"></mat-divider>

  <mat-card-content>
    <app-entity-listing
      [state]="permitAccess?.length ? state.Ready : state.Empty"
      [totalCount]="permitAccess?.length"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [emptyStateMainLabel]="'General.NoDataAvailableYet' | translate"
      [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate"
      (pageIndexChange)="onPageIndexChange($event)"
      (pageSizeChange)="filters.params = { limit: $event, offset: 0 }"
    >

      <table mat-table [dataSource]="dataSource" matSort  class="table scrollable scrollable--x">
        <ng-container matColumnDef="label">
          <th mat-header-cell *matHeaderCellDef class="id-header">{{ "Inputs.Name" | translate }}</th>
          <td mat-cell *matCellDef="let element" [ngClass]="{ 'cell-no-data': !element.label }">{{ element.label }}</td>
        </ng-container>

        <ng-container matColumnDef="receiver">
          <th mat-header-cell *matHeaderCellDef class="id-header">{{ "Inputs.Receiver" | translate }}</th>
          <td mat-cell *matCellDef="let element" [ngClass]="{ 'cell-no-data': !element.receiver }">{{ element.receiver?.name }}</td>
        </ng-container>

        <ng-container matColumnDef="expirationDate">
          <th mat-header-cell *matHeaderCellDef class="id-header">{{ "Inputs.Receiver" | translate }}</th>
          <td mat-cell *matCellDef="let element" [ngClass]="{ 'cell-no-data': !element.expirationDate }">{{ element.expirationDate | date }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="id-header"></th>
          <td mat-cell *matCellDef="let element">
            <div class="flex align-center w-100" [matMenuTriggerFor]="menu" *ngIf="isCustomerTypeSAAS">
              <div class="ml-auto mr-auto">
                <app-icon name="menu-vert"  class="cursor-pointer text-700"></app-icon>
              </div>

              <mat-menu class="item-actions" #menu>
                <mat-option (click)="handleEdit(element)">{{'Buttons.Edit' | translate}}</mat-option>
                <mat-option (click)="handleDelete(element)"><span class="text-error">{{'Buttons.Delete' | translate}}</span></mat-option>
              </mat-menu>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <!--    (click)="navigateToDetailsPage(row.id)"-->
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </app-entity-listing>
  </mat-card-content>
</mat-card>


<!-- smart Detection Modal -->
<app-modal
  #permitAccessDialog
  title="{{'Receivers.PermitAccess' | translate}}"
  [maxWidth]="700"
  [padding]="24"
  [textColor]="'var(--color-dark)'"

>
  <form *ngIf="permitAccessDialog.isModalOpened" [formGroup]="formArray" (submit)="handleSavePermitAccess()">
    <app-state-section [state]="sectionState">
      <app-permit-access-control-list
        [formArray]="formArray">
      </app-permit-access-control-list>

      <div class="row">
        <div class="col-12 col-sm-auto">
          <button type="button" mat-raised-button class="btn-secondary" (click)="permitAccessDialog.closeModal()">
            {{'Buttons.Cancel' | translate}}
          </button>
        </div>
        <div class="col-12 col-sm-6 col-md-5 col-lg-4 col-xl-3 ml-auto">
          <button
            [disabled]="formArray.invalid || !formArrayHasValidValue()"
            type="submit"
            mat-raised-button
            color="primary"
            class="d-block w-100">
            {{'Buttons.Save' | translate}}
          </button>
        </div>
      </div>
    </app-state-section>
  </form>
</app-modal>


<app-modal
  #editPermitAccessDialog
  title="{{'Receivers.PermitAccess' | translate}}"
  [maxWidth]="700"
  [padding]="24"
  [textColor]="'var(--color-dark)'"

>
  <div
    *ngIf="editPermitAccessDialog.isModalOpened" (submit)="handleUpdatePermitAccess()">
    <app-state-section [state]="sectionState">
      <app-permit-access-control
        [columnClass]="'col-12'"
        [receivers]="receivers"
        [formControl]="editFormControl">
      </app-permit-access-control>

      <div class="row">
        <div class="col-12 col-sm-auto">
          <button type="cancel" mat-raised-button class="btn-secondary" (click)="editPermitAccessDialog.closeModal()">
            {{'Buttons.Cancel' | translate}}
          </button>
        </div>
        <div class="col-12 col-sm-6 col-md-5 col-lg-4 col-xl-3 ml-auto">
          <button
            [disabled]="editFormControl.invalid"
            type="button"
            mat-raised-button
            color="primary"
            class="d-block w-100"
            (click)="handleUpdatePermitAccess()">
            {{'Buttons.Save' | translate}}
          </button>
        </div>
      </div>
    </app-state-section>
  </div>
</app-modal>
